import { useEffect, useMemo } from 'react';
import { useSearchParams } from 'react-router-dom';
import { useRegisterComponent } from '../../orchestrator';
import { useAppDispatch, useAppSelector } from '../../../stores/redux.store';
import { useNavigateSoftOrHard } from '../../../utilities/hooks/useNavigateSoftOrHard';
import { setGlobalStateLoading } from '../../../utilities/hooks/useGlobalPageState';

export const useOrgLoginConfig = () => {
  useRegisterComponent(useOrgLoginConfig.name);

  const [searchParams] = useSearchParams();
  const dispatch = useAppDispatch();
  const navigate = useNavigateSoftOrHard();
  const orgLoginConfigAutoRedirect = useAppSelector(state => state.orgLoginConfig.autoRedirect);
  const orgLoginConfigSamlConnectionId = useAppSelector(
    state => state.orgLoginConfig.samlConnectionId
  );

  const redirectToSingleSignOn = useMemo(
    () =>
      orgLoginConfigSamlConnectionId
        ? () => {
            // Set global state loading to true to keep the page in a loading state during the redirect
            dispatch(setGlobalStateLoading(true));

            const queryParams = new URLSearchParams([
              ['connection', orgLoginConfigSamlConnectionId],
              ...searchParams, // Include any existing query params (eg. continue URL)
            ]);

            navigate(`/login/saml/start?${queryParams}`);
          }
        : undefined,
    [dispatch, navigate, orgLoginConfigSamlConnectionId, searchParams]
  );

  useEffect(() => {
    if (redirectToSingleSignOn && orgLoginConfigAutoRedirect) {
      redirectToSingleSignOn();
    }
  }, [orgLoginConfigAutoRedirect, redirectToSingleSignOn]);

  return { redirectToSingleSignOn };
};
